import weTours from './weTours/EmailBody';
import buspaket from './buspaket/EmailBody';
import welcome from './welcome/EmailBody';
import eurobin from './eurobin/EmailBody';

export default function (organisationId = 1, body = '', phone = '', email = null, locale = 'de_DE') {
    if(organisationId === 2){
        return weTours(body, phone, email, locale);
    } else if(organisationId === 3) {
        return welcome(body, phone, email, locale);
    } else if(organisationId === 11) {
        return eurobin(body, phone, email, locale);
    } else {
        return buspaket(body, phone, email, locale);
    }
}
